<template>
  <div
    class="modal"
    v-if="visible"
    @click.self="$emit('update:visible', false)"
  >
    <div class="modal-content">
      <div class="img" :style="{ backgroundImage: `url(${data.image})` }"></div>
      <div class="title">{{ data.productName }}</div>
      <div class="tip">(包含{{ num }}个景点)</div>
      <div class="buy-tip">
        <div>试听结束</div>
        <div>请购买后收听</div>
      </div>
      <div class="buy" @click="buy">立即购买</div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    visible: Boolean,
    data: Object,
    user: Object,
    num: Number,
  },
  methods: {
    buy() {
      this.$emit("update:visible", false);
      this.$emit("buy");
    },
  },
};
</script>

<style lang="scss" scoped>
.modal {
  position: fixed;
  left: 0;
  top: 0;
  bottom: 0;
  right: 0;
  background: rgba(0, 0, 0, 0.8);
  z-index: 1000;
  display: flex;
  justify-content: center;
  align-items: center;
  .title {
    font-size: 32px;
    font-weight: 500;
  }
  .buy {
    padding: 10px;
    border-radius: 50px;
    color: #fff;
    background: $detail-pay-btn;
    width: 60%;
    margin: 0 auto;
    margin-top: 40px;
  }
  .tip {
    color: #666;
    font-size: 24px;
  }
  .buy-tip {
    color: red;
    margin-top: 20px;
  }
  .modal-content {
    background: #fff;
    width: 80%;
    text-align: center;
    padding: 40px;
    border-radius: 5px;
    .img {
      width: 120px;
      height: 120px;
      margin-top: -80px;
      background: #fff no-repeat center;
      border: solid 5px #fff;
      background-size: cover;
      display: inline-block;
      border-radius: 50%;
    }
  }
}
</style>
